<script lang="ts">
	import Formatted from "@components/common/Formatted.svelte";
	import type { Snippet } from "svelte";
	import type { ClassValue } from "svelte/elements";
	import { idFromAnchor } from "@core/schema/utils/idFromAnchor.js";

	const {
		heading,
		children,
		media,
		class: customClass,
		mediaClass,
		imageLeft,
		anchor,
		wideMedia,
	}: {
		heading: string | Snippet;
		children?: Snippet;
		media?: Snippet;
		class?: ClassValue;
		mediaClass?: ClassValue;
		imageLeft?: boolean;
		anchor?: string;
		wideMedia?: boolean;
	} = $props();
</script>

<section class={["md:grid-container full-width py-23.5 overflow-hidden", customClass]} id={idFromAnchor(anchor)}>
	<div
		class={[
			"flex items-center flex-col px-4 md:px-0 gap-10 md:gap-15",
			wideMedia ? "xl:gap-38" : "lg:gap-38",
			wideMedia
				? imageLeft
					? "lg:flex-row-reverse"
					: "lg:flex-row"
				: imageLeft
					? "md:flex-row-reverse"
					: "md:flex-row",
		]}
	>
		<div class="flex flex-col gap-16 min-w-0">
			{#if typeof heading === "string"}
				<div class="text-black font-bold heading-1">
					<Formatted text={heading} />
				</div>
			{:else}
				{@render heading()}
			{/if}
			<div class="font-light text-5 grow">
				{@render children?.()}
			</div>
		</div>
		<div
			class={[
				"relative grow-0 shrink-0 max-w-full",
				wideMedia ? "w-171 h-114 lg:w-[60%] lg:h-auto lg:aspect-[3/2] xl:w-171 xl:h-114" : "w-93 h-100 md:h-140",
				mediaClass,
			]}
		>
			{@render media?.()}
		</div>
	</div>
</section>
